/**
 * Powered by Strava — Official brand lockup per Strava Brand Guidelines.
 * https://developers.strava.com/guidelines/
 *
 * Rules followed:
 *  - "Powered by Strava" text uses uppercase, the Strava wordmark is in Strava Orange (#FC4C02).
 *  - "POWERED BY" is rendered with sufficient padding around the lockup.
 *  - Logo is not stretched, distorted, or recolored except the approved orange-on-dark variant.
 */
export default function PoweredByStrava({ size = "sm", className = "" }) {
  const sizes = {
    sm: { wrapper: "gap-1.5 px-2.5 py-1", small: "text-[9px]", brand: "text-[11px]" },
    md: { wrapper: "gap-2 px-3 py-1.5", small: "text-[10px]", brand: "text-[13px]" },
    lg: { wrapper: "gap-2.5 px-4 py-2", small: "text-xs", brand: "text-base" },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <span
      data-testid="powered-by-strava"
      className={`inline-flex items-center ${s.wrapper} bg-black/70 border border-zinc-800 ${className}`}
      aria-label="Powered by Strava"
    >
      <span className={`font-mono ${s.small} tracking-[0.25em] uppercase text-zinc-400`}>
        Powered by
      </span>
      <span
        className={`font-display ${s.brand} font-extrabold tracking-[0.15em] uppercase`}
        style={{ color: "#FC4C02" }}
      >
        STRAVA
      </span>
    </span>
  );
}
